import { useTranslation } from 'next-i18next';
import React, { use, useEffect } from 'react';
import { GetArticuloCompraBeseif, ModeCompraBeseif } from '@/objects/Beseif';
import { useServices } from '@/context/ServicesProvider';
import { useNotificationContext } from '@/context/NotificationContext';
import RowDatosBeseif from './listas/RowDatosBeseif';
import RowNoData from '@/components/elements/RowNoData';

interface Props {
    modoComprasBeseif: ModeCompraBeseif;
}


function BeseifSeguimientoArticulos({ modoComprasBeseif }: Props) {

    const { t } = useTranslation();

    const { beseifQueries } = useServices();
    const { userData } = useNotificationContext();

    const [articulosCompraBeseif, setArticulosCompraBeseif] = React.useState<GetArticuloCompraBeseif[]>([]);

    useEffect(() => {
        beseifQueries?.obtener_articulos_beseif(userData?.id_user!, modoComprasBeseif).then((response) => {
            if (response.status == 200) {
                setArticulosCompraBeseif(response.data);
            }
        }).catch((error) => {

        });
    }, [modoComprasBeseif]);


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', minHeight: 0, margin: 0, padding: 0, overflow: 'hidden' }}>
            {articulosCompraBeseif.length > 0 ?
                articulosCompraBeseif.map((articulo) => (
                    <div key={articulo.id_articulo + articulo.categoria} style={{ padding: '10px' }}>
                        <RowDatosBeseif getArticuloCompraBeseif={articulo} />
                    </div>
                ))
                :
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <RowNoData texto={modoComprasBeseif === ModeCompraBeseif.COMPRAS ? t('menu:secciones.mis_compras.seguimiento.no_info_compras') : t('menu:secciones.mis_compras.seguimiento.no_info_ventas')} />
                </div>
            }

        </section>
    );
}

export default BeseifSeguimientoArticulos;